import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  IconButton,
  Stack,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import apiClient from "./api/apiClient";

const MeetingRequests = () => {
  const [requests, setRequests] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      const fetchRequests = async () => {
        try {
          const response = await apiClient.get(`/meetingschedulers/initiator/${userId}`);
          console.log("Meeting requests response:", response.data);
          setRequests(response.data);
        } catch (error) {
          console.error("Error fetching meeting requests:", error);
        }
      };

      fetchRequests();
    }
  }, []);

  const handleEdit = (requestId) => {
    navigate(`/editmeetingrequest/${requestId}`);
  };

  const handleAddRequest = () => {
    navigate("/createmeetingrequest");
  };

  return (
    <div style={{ padding: "20px" }}>
      <Typography variant="h5" gutterBottom>
        Meeting Requests
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleAddRequest}
        style={{ marginBottom: "10px" }}
      >
        Add Meeting Request
      </Button>

      <TableContainer component={Paper} style={{ maxHeight: 400 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Proposed Dates</TableCell>
              <TableCell>Invitee</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {requests.map((req) => (
              <TableRow key={req.id}>
                <TableCell>{req.id}</TableCell>
                <TableCell>{req.title}</TableCell>
                <TableCell>
                  {req.proposedDates && req.proposedDates.length > 0 ? (
                    req.proposedDates.map((date, idx) => (
                      <div key={idx}>{new Date(date).toLocaleString()}</div>
                    ))
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell>{req.inviteeName || "-"}</TableCell>
                <TableCell align="center">
                  <Stack direction="row" spacing={1} justifyContent="center">
                    <IconButton onClick={() => handleEdit(req.id)} title="Edit">
                      <EditIcon />
                    </IconButton>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
            {requests.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No meeting requests found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default MeetingRequests;
